module.exports = __webpack_public_path__ + "img/zw.fdf31fa4.svg";